/*
 *  This file log-errors.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NewRelicHandlerService } from '../newrelic-handler/newrelic-handler.service';

@Injectable()
export class LogErrorsService {

  constructor(private readonly _newRelic: NewRelicHandlerService) {}

  logError(error: any): void {
    console.error('log error ', error);

    // HTTP errors are already reported by the interceptor — skip to avoid duplicates.
    if (!this._newRelic.isEnabled || error instanceof HttpErrorResponse) {
      return;
    }

    const details = this.extractErrorDetails(error);
    const err = new Error(error?.message || 'Unknown Error');
    err.name = details['errorType'] as string;
    err.stack = error?.stack ?? err.stack;
    this._newRelic.noticeError(err, details);
  }

  private extractErrorDetails(error: any): Record<string, string | number | boolean> {
    const base: Record<string, string | number | boolean> = {
      source: 'LogErrorsService',
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      pageUrl: window.location.href,
      errorType: 'UnknownError'
    };

    if (error instanceof Error) {
      return {
        ...base,
        errorType: 'JavaScriptError',
        errorName: error.name,
        errorMessage: error.message,
        stackTrace: ((error as any).originalStack ?? error.stack ?? '').slice(0, 4096)
      };
    }

    if (typeof error === 'string') {
      return { ...base, errorType: 'StringError', errorMessage: error };
    }

    if (error && typeof error === 'object') {
      return {
        ...base,
        errorType: 'ObjectError',
        errorMessage: JSON.stringify(error).slice(0, 500)
      };
    }

    return base;
  }
}
